module.exports = __webpack_public_path__ + "static/DairyBasedAndInstantFatPowders-2043c79b6e3561cfdb41bb0072be9ee2.webp";